import { render } from "./Punishment.vue?vue&type=template&id=12bdd3f3"
import script from "./Punishment.vue?vue&type=script&lang=js"
export * from "./Punishment.vue?vue&type=script&lang=js"

import "./Punishment.vue?vue&type=style&index=0&id=12bdd3f3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__